export { getAgentName } from './utils/getAgentName';

export const CHAT_ENDPOINT = '/platform/gateway-proxy-v2/concierge/chat';
export const CHAT_ENDPOINT_REVENUE_IN_ONE_ID =
  '/revenue/gateway-api/concierge/chat';
export const CHAT_ENDPOINT_REVENUE = '/revpro/gateway-api/concierge/chat';
export const REVENUE_AGENT_ENDPOINT = '/copilot/userjob/conversations';

/** OneID fullscreen Zuora AI app (not Billing `/platform/apps/zuora-ai`). */
export const ONE_ID_FULL_SCREEN_URL = '/one-id/admin/zuora-ai';

export const CONCIERGE_CHAT_IS_OPEN = 'ZNav.ConciergeIsChatOpen';
/**
 * Set once the auto expand setting has been acted on in this browser
 * session (panel auto-expanded, or the user closed it), so reloads and SPA
 * navigations never re-expand the panel behind the user's back.
 */
export const CONCIERGE_AUTO_EXPAND_HANDLED = 'ZNav.ConciergeAutoExpandHandled';
/** Drawer width when the concierge panel is open (matches ConciergeCard). */
export const CONCIERGE_SIDEBAR_WIDTH_PX = 450;
/** Gap from the viewport right edge to the panel (matches ConciergeCard). */
export const CONCIERGE_SIDEBAR_INSET_PX = 10;
export const CONCIERGE_CHAT_EVENT_COMMAND = 'zAIChat:command';
export const CONCIERGE_CHAT_EVENT_SET_PROMPT = 'zAIChat:setPrompt';
/** `id` of the floating AI launcher button (focus target after panel closes). */
export const CONCIERGE_LAUNCHER_ELEMENT_ID = 'z-ai-concierge-launcher';
